<template>
  <container
    v-bind="container"
    class="relative w-full"
    :base-class="[
      'w-full relative flex items-center h-9 text-gray-800 text-sm relative',
      disabled ? 'opacity-75 pointer-events-none' : ''
    ]"
  >
    <o-dropdown
      ref="dropdown"
      class="w-full"
      :arrow="false"
      placement="bottom-start"
      container-class="-mx-2"
      detect-overflow
      :disabled="disabled"
    >
      <div class="w-full h-9 relative flex items-center justify-between text-sm text-gray-800 cursor-pointer pr-4 px-2">
        <slot v-if="_value !== null && _value !== undefined" name="value" :value="value">
          {{ _value }}
        </slot>

        <p v-if="_value === null || _value === undefined" class="text-sm text-gray-500">
          {{ placeholder }}
        </p>

        <div class="absolute inset-y-0 pointer-events-none right-0 flex items-center px-2 text-gray-600">
          <o-icon icon="accordion" :size="12" />
        </div>
      </div>

      <template #content="{ overflow }">
        <div
          class="w-80 text-sm flex flex-col"
          :style="{
            height: overflow && overflow.bottom > 0 ? `${400 - overflow.bottom}px` : '400px'
          }"
        >
          <div v-if="search" class="w-full flex items-center border-b">
            <o-icon icon="search" class="text-gray-500 ml-4" :size="14" />
            <input v-model="query" type="text" placeholder="Search" class="py-2 px-3 w-full">
          </div>

          <slot name="content">
            <o-scroll v-if="filtered">
              <ul
                v-for="(category, indexCategory) in filtered"
                :key="indexCategory"
              >
                <li v-if="category.label" class="text-gray-500 text-xs uppercase tracking-wider mt-3 mb-1 px-4">
                  {{ category.label }}
                </li>
                <li
                  v-for="(option, indexOption) in category.options"
                  :key="indexOption"
                  class="text-gray-900 cursor-pointer select-none relative py-2 px-3  transition-colors"
                  :class="[
                    option.value === value ? 'bg-green-100 text-green-700 hover:bg-green-100' : 'hover:bg-gray-200',
                    option.class
                  ]"
                  role="option"
                  @click="handleOptionClick(option.value)"
                >
                  <slot name="option" :option="option">
                    {{ option.label }}
                  </slot>
                </li>
              </ul>
            </o-scroll>

            <p v-else class="text-center p-4 text-gray-600">
              No options found.
            </p>
          </slot>
        </div>
      </template>
    </o-dropdown>

    <template #leading>
      <slot name="leading" />
    </template>

    <template #trailing>
      <slot name="trailing" />
    </template>
  </container>
</template>

<script>
import Fuse from 'fuse.js'

import Container from './Container'

import classes from '@/mixins/fields/classes.js'
import attributes from '@/mixins/fields/attributes.js'
import methods from '@/mixins/fields/methods.js'
import multi from '@/mixins/fields/multi.js'
import input from '@/mixins/fields/input.js'

export default {
  components: {
    Container
  },
  mixins: [attributes, classes, methods, multi, input],
  props: {
    search: {
      type: Boolean,
      default: false
    },
    categorised: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, Object, String, Number],
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select an option'
    },
    defaultSizeClass: {
      type: [String, Object, Array],
      default: 'h-9'
    },
    largeSizeClass: {
      type: [String, Object, Array],
      default: 'text-lg h-12'
    },
    smallSizeClass: {
      type: [String, Object, Array],
      default: 'text-sm h-8'
    }
  },
  data () {
    return {
      query: ''
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    filtered () {
      let items = this.options

      if (this.query.length) {
        if (this.categorised) {
          const arrays = Object.values(items).map(({ options }) => options)
          items = [].concat(...arrays)
        }

        const fuse = new Fuse(items, {
          keys: [
            'text',
            'info',
            'value',
            'label'
          ]
        })
        const results = fuse.search(this.query)
        items = results.map(({ item }) => item)
      }

      if (!this.categorised || this.query.length) {
        return [{
          options: items
        }]
      }

      return items
    }
  },
  methods: {
    handleOptionClick (value) {
      this._value = value
      this.query = ''

      this.$refs.dropdown.close()
    }
  }
}
</script>
